var map = {
	"./content-deco-1.webp": 1469,
	"./content-deco-2.webp": 1470,
	"./deposit-icon.webp": 1471,
	"./home-icon-active.webp": 1472,
	"./home-icon.webp": 1473,
	"./live-icon-active.webp": 1474,
	"./live-icon.webp": 1475,
	"./me-icon-active.webp": 1476,
	"./me-icon.webp": 1477,
	"./product-overview-bg.webp": 1478,
	"./promos-icon-active.webp": 1479,
	"./promos-icon.webp": 1480,
	"./services-bg.webp": 1481,
	"./sponsor-icon-active.webp": 1482,
	"./sponsor-icon.webp": 1483,
	"./vip-icon.webp": 1484,
	"./withdraw-icon.webp": 1485,
	"./wwr-img.webp": 1486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;